/**
 * Kabuk giriş noktası.
 *
 * index.html bunu tek bir <script type="module"> ile yükler. Yeni modüller
 * buraya kaydolur; eski js/*.js dosyaları hiç değişmeden çalışmaya devam eder.
 *
 * Yeni bir sayfa göç ettirmek için:
 *   1. src/features/<ad>/ klasörünü oluştur
 *   2. aşağıdaki listeye bir satır ekle
 *   3. eski js/<ad>.js dosyasını ve index.html'deki script etiketini sil
 * core.js'e dokunulmaz — go() sarmalayıcısı bir kez kuruldu, sayfa başına değil.
 *
 * Kaldırmak için: klasörü sil, listeden satırı çıkar. Ardından
 * `node scripts/check-refs.mjs` eski koddan kalan çağıranları gösterir.
 */

import type { WebFeature } from './feature.ts';
import { attachToLegacyRouter, bootAll, register, registered } from './registry.ts';
import solutions from '../features/solutions/feature.ts';
import consent from '../features/consent/feature.ts';
import offline from '../features/offline/feature.ts';
import accountType from '../features/account-type/feature.ts';
import aiConsent from '../features/ai-consent/feature.ts';
import firmLink from '../features/firm-link/feature.ts';
import extract from '../features/extract/feature.ts';
import aiPage from '../features/ai-page/feature.ts';
import fileAccess from '../features/file-access/feature.ts';
import docRequests from '../features/doc-requests/feature.ts';
import navShape from '../features/nav-shape/feature.ts';
import firmWorkspace from '../features/firm-workspace/feature.ts';
import firmTeam from '../features/firm-team/feature.ts';
import myAccountant from '../features/my-accountant/feature.ts';
import teamJoin from '../features/team-join/feature.ts';
import orbAgent from '../features/orb-agent/feature.ts';
import monthClose from '../features/month-close/feature.ts';
import billing from '../features/billing/feature.ts';
import firmAi from '../features/firm-ai/feature.ts';
import customerAi from '../features/customer-ai/feature.ts';
import overviewExtras from '../features/overview-extras/feature.ts';
import resultsClosed from '../features/results-closed/feature.ts';
import onboardingSides from '../features/onboarding-sides/feature.ts';

const FEATURES: WebFeature[] = [
  /* extract ONCE: tarih/tutar okumasi digerlerinin altinda duruyor. */
  extract,
  solutions, consent, offline, accountType, aiConsent, firmLink,
  aiPage, fileAccess, docRequests,
  navShape, firmWorkspace, firmTeam, myAccountant, teamJoin, orbAgent, monthClose, billing, firmAi, customerAi, overviewExtras, resultsClosed, onboardingSides,
];

for (const feature of FEATURES) {
  try {
    register(feature);
  } catch (e) {
    console.error(`[kabuk] ${feature.id} kaydedilemedi:`, e);
  }
}

attachToLegacyRouter();
bootAll();

console.info(`[kabuk] ${registered().length} modül: ${registered().map((f) => f.id).join(', ') || '—'}`);
